import { render, staticRenderFns } from "./userPhoneChange.vue?vue&type=template&id=16a6aa52&scoped=true&"
import script from "./userPhoneChange.vue?vue&type=script&lang=js&"
export * from "./userPhoneChange.vue?vue&type=script&lang=js&"
import style0 from "./userPhoneChange.vue?vue&type=style&index=0&id=16a6aa52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a6aa52",
  null
  
)

component.options.__file = "userPhoneChange.vue"
export default component.exports